var map = {
	"./WaterPriceCharging.svg": "dJJz",
	"./WaterPricing.svg": "e7lq",
	"./approval.svg": "Fsqj",
	"./assets.svg": "7tfs",
	"./barCode.svg": "svdS",
	"./collection.svg": "a4vn",
	"./create.svg": "49zR",
	"./details.svg": "MIkI",
	"./dike.svg": "2808",
	"./draft.svg": "rKLr",
	"./emergencyDuty.svg": "fNvr",
	"./eye.svg": "4wdf",
	"./farm.svg": "NUlq",
	"./file.svg": "fQ0v",
	"./flood.svg": "aqDu",
	"./flow.svg": "4V0V",
	"./flowDetails.svg": "yBuD",
	"./flowmonitor.svg": "siGm",
	"./folder.svg": "XXSE",
	"./form.svg": "sTIr",
	"./gate.svg": "6WwC",
	"./home.svg": "U9Ws",
	"./information.svg": "9RvR",
	"./irrigate.svg": "vZOt",
	"./list.svg": "vuHp",
	"./login-mall.svg": "xzZT",
	"./management.svg": "bZrc",
	"./meter.svg": "vhrO",
	"./monitor.svg": "Lu+8",
	"./monitoring.svg": "GpP4",
	"./office.svg": "PdyU",
	"./outlet.svg": "/Yxz",
	"./password.svg": "QjmH",
	"./patrol.svg": "62OK",
	"./pressure.svg": "132G",
	"./project.svg": "6CSd",
	"./publicity.svg": "lox9",
	"./quality.svg": "8mo1",
	"./rainfall.svg": "Mo9h",
	"./rate.svg": "h/JX",
	"./reservoir.svg": "iOvc",
	"./river.svg": "cz1s",
	"./riverway.svg": "hCJ5",
	"./sandExtraction.svg": "77wT",
	"./scheme.svg": "H9IQ",
	"./sewage.svg": "Ei5m",
	"./soilMoisture.svg": "40g3",
	"./statistics.svg": "2O5N",
	"./supervise.svg": "mTEX",
	"./transfer.svg": "S35e",
	"./uav.svg": "Tv7n",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./vehicle.svg": "fQRN",
	"./warning.svg": "TcIt",
	"./water.svg": "r9pr",
	"./waterPic.svg": "LsiH",
	"./waterQuality.svg": "rtP4",
	"./waterRightSupervision.svg": "hE3X",
	"./waterWorks.svg": "COax",
	"./waterplant.svg": "UDTa",
	"./workorder.svg": "tRKm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 80